import {SortDirection, SortStrategy, defaultFilename} from "./constants";
import {type Configuration} from "../types";
import {type AxiosResponse} from "axios";

export const extractFilename = (response: AxiosResponse) =>
  (
    Object.entries(response.headers).find(
      header => header[0].toLocaleLowerCase() === "content-disposition"
    )?.[1] as string
  )
    ?.split("filename")?.[1]
    ?.replace(/[=";]/g, "")
    ?.trim();

export const saveZipToDrive = (response: AxiosResponse) => {
  const blob = new Blob([response.data]);
  const a = document.createElement("a");
  const blobURL = URL.createObjectURL(blob);
  a.download = extractFilename(response) ?? defaultFilename;
  a.href = blobURL;
  a.click();
};

const sortStrategySortFunctionAscendingMap: {
  [key in SortStrategy]: (a: Configuration, b: Configuration) => number;
} = {
  [SortStrategy.ID]: (a: Configuration, b: Configuration) => a.id - b.id,
  [SortStrategy.NAME]: (a: Configuration, b: Configuration) => a.name?.localeCompare(b.name),
  [SortStrategy.DATE]: (a: Configuration, b: Configuration) =>
    a.lastUpdate.localeCompare(b.lastUpdate),
  [SortStrategy.NONE]: () => undefined
};

const sortStrategySortFunctionDescendingMap: {
  [key in SortStrategy]: (a: Configuration, b: Configuration) => number;
} = {
  [SortStrategy.ID]: (a: Configuration, b: Configuration) => b.id - a.id,
  [SortStrategy.NAME]: (a: Configuration, b: Configuration) => b.name?.localeCompare(a.name),
  [SortStrategy.DATE]: (a: Configuration, b: Configuration) =>
    b.lastUpdate.localeCompare(a.lastUpdate),
  [SortStrategy.NONE]: () => undefined
};

export const sortedConfigurations = (
  configurations: Configuration[],
  sortStrategy: SortStrategy,
  sortDirection: SortDirection
) =>
  configurations.sort(
    sortDirection === SortDirection.ASCENDING
      ? sortStrategySortFunctionAscendingMap[sortStrategy]
      : sortStrategySortFunctionDescendingMap[sortStrategy]
  );

export const sortHeaderClassName = (currentStrategy: SortStrategy, headerStrategy: SortStrategy) =>
  `no-configurations-header ${currentStrategy === headerStrategy ? "sortheader" : ""}`;
